"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertMessageError = exports.convertGiftWithShadowMessage = exports.convertGiftToMessage = void 0;

var _ramda = require("ramda");

var convertGiftToMessage = (0, _ramda.applySpec)({
  isDraft: (0, _ramda.pipe)((0, _ramda.prop)('is_ready_to_be_sent'), _ramda.not),
  subject: (0, _ramda.prop)('subject'),
  defaultSubject: (0, _ramda.prop)('default_subject'),
  text: (0, _ramda.prop)('message'),
  previewUrl: (0, _ramda.prop)('recipient_landing_page')
});
exports.convertGiftToMessage = convertGiftToMessage;
var convertGiftWithShadowMessage = (0, _ramda.converge)(_ramda.mergeRight, [(0, _ramda.applySpec)({
  shadowText: (0, _ramda.prop)('message'),
  shadowSubject: (0, _ramda.prop)('subject')
}), convertGiftToMessage]);
exports.convertGiftWithShadowMessage = convertGiftWithShadowMessage;
var convertMessageError = (0, _ramda.applySpec)({
  text: (0, _ramda.pipe)((0, _ramda.propOr)([null], 'message'), _ramda.head),
  subject: (0, _ramda.pipe)((0, _ramda.propOr)([null], 'subject'), _ramda.head)
});
exports.convertMessageError = convertMessageError;